import { designToken, quickProperty } from '../component-tokens';
import { tertiaryElementFocus, borderBase } from './common';
const menuItemAttrs = Object.assign(Object.assign({}, borderBase), { display: quickProperty('flex'), 'align-items': quickProperty('center'), 'border-color': designToken('interactive-02'), cursor: quickProperty('pointer'), font: designToken('body-small'), height: quickProperty('36px'), width: quickProperty('100%'), transition: quickProperty('unset'), borderRadius: quickProperty('0'), padding: quickProperty('0 4px'), position: quickProperty('relative'), color: designToken('text-01'), outline: quickProperty('0'), 'text-decoration': quickProperty('none') });
export const menuTokens = {
    name: 'menu',
    reactImports: 'Menu, MenuItem, MenuSection, MenuSeparator',
    attributes: {
        'border-radius': designToken('spacing-01'),
        margin: quickProperty('0'),
        padding: quickProperty('8px 0'),
        width: quickProperty('100%'),
        'list-style': quickProperty('none'),
        display: quickProperty('inline-flex'),
        'flex-direction': quickProperty('column'),
        'word-break': quickProperty('break-word'),
    },
    tag: 'chameleon-menu',
    sizes: [
        {
            name: 'small',
            children: [
                {
                    alias: 'menu-item-small',
                    name: 'menu-item',
                    attributes: {
                        font: designToken('caption-default-01'),
                        height: quickProperty('24px'),
                        padding: quickProperty('4px'),
                    },
                },
            ],
        },
    ],
    children: [
        {
            alias: 'menu-item',
            name: 'menu-item',
            tag: 'li',
            attributes: menuItemAttrs,
            states: [
                {
                    alias: `menu-item-hover`,
                    name: 'hover',
                    attributes: {
                        'background-color': designToken('interactive-01'),
                        'border-color': designToken('interactive-01'),
                        color: designToken('text-04'),
                    },
                },
                {
                    alias: `menu-item-focus`,
                    name: 'focus',
                    attributes: Object.assign(Object.assign({}, tertiaryElementFocus), { color: designToken('text-01') }),
                },
                {
                    alias: `menu-item-active`,
                    name: 'active',
                    attributes: {
                        'box-shadow': quickProperty('none'),
                        'border-color': designToken('interactive-02'),
                        color: designToken('text-04'),
                        'background-color': designToken('pressed-primary'),
                    },
                },
            ],
        },
        {
            name: 'menu-item-disabled',
            alias: 'menu-item-disabled',
            attributes: {
                color: designToken('text-03'),
                background: quickProperty('none'),
                'border-color': quickProperty('transparent'),
            },
        },
        {
            name: 'separator',
            attributes: {
                'border-top': quickProperty('1px solid'),
                'border-color': designToken('field-01'),
                margin: quickProperty('8px 0'),
                height: quickProperty('1px'),
            },
        },
        {
            name: 'menu-item-danger',
            alias: 'menu-item-danger',
            attributes: {
                color: designToken('danger-01'),
                '--goto-icon-color': designToken('danger-01'),
            },
        },
        {
            name: 'menu-item-secondary',
            alias: 'menu-item-secondary',
            attributes: {
                '--goto-icon-color': designToken('interactive-01'),
            },
        },
        {
            name: 'section',
            attributes: {
                display: quickProperty('flex'),
                margin: quickProperty('4px 16px'),
            },
        },
        {
            name: 'menu-item-toggleable',
            alias: 'menu-item-toggleable',
            attributes: {
                '--goto-icon-color': designToken('interactive-01'),
                padding: quickProperty('0 16px'),
            },
        },
    ],
};
